module.exports = __webpack_public_path__ + "img/Beifahrerseite_1T_Heckmotor_YNKSBYE.e381f165.jpg";